/**
 * Imports core polyfills documented here:
 * https://docs.csnzoo.com/frontend/javascript/getting-started/compatibility/
 *
 * @author    Will Van Rensselaer <wvanrensselaer@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */
import 'core-js/es';
import 'whatwg-fetch';
import 'intersection-observer';
import './intl-pluralrules';
import './request-idle-callback';
